import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type WishlistTag, wishlistTag } from "../schemas/wishlistTag";

export const shareWishlistProps = z
  .object({
    tag: z.number(),
    token: z.string(),
  })
  .extend(requestConfig.shape);

export type ShareWishlistProps = z.infer<typeof shareWishlistProps>;

export const shareWishlist = async (
  args: ShareWishlistProps,
): Promise<WishlistTag> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag,
    token,
    proxyAuthSecret,
  } = parseServiceInput(shareWishlistProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/tag/${tag}/share`, {
    method: "PUT",
    headers,
  });

  return parseServiceOutput(response, wishlistTag, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
